module.exports = {
          srcSet: __webpack_public_path__ + "bef8a1ff6e6f1ca4ca196119462af18b-63.png"+" 63w",
          images:[ {path: __webpack_public_path__ + "bef8a1ff6e6f1ca4ca196119462af18b-63.png",width: 63,height: 72}],
          src: __webpack_public_path__ + "bef8a1ff6e6f1ca4ca196119462af18b-63.png",
          toString:function(){return __webpack_public_path__ + "bef8a1ff6e6f1ca4ca196119462af18b-63.png"},
          
          width: 63,
          height: 72
        }